<!-- eslint-disable default-case -->
<script setup lang="ts">
import type { ButtonType } from './';

export interface Props {
  type?: ButtonType;
  isDisabled?: boolean;
  ariaLabel?: string;
}

withDefaults(defineProps<Props>(), {
  type: 'button',
  ariaLabel: '',
});
</script>

<template>
  <button
    :type="type"
    :disabled="isDisabled"
    :aria-label="ariaLabel"
    class="hover:bg-blue-100 focus:shadow-secondaryButtonFocus"
    :class="{
      'border border-blue-700 shadow-primaryButton': !isDisabled,
    }"
  >
    <slot />
  </button>
</template>
